import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

export function useC505Permission() {
  const perms = useModulePermission(Modules.PWC505);

  return {
    canView: perms.canView,
    canApprove: perms.canApprove,
    hasAnyPermission: perms.hasAnyPermission,
  };
}
